import { defaultClient } from './client';

const LC = '/leaked-credentials';
const DUMP_DATA = `${LC}/dump-data`;
const GET_DUMP_FILE = `${LC}/get-dump-file`;

export const fetchDumpData = ({ dumpIds }) => defaultClient.post(DUMP_DATA, { dump_ids: dumpIds });

export const getDumpFileUrl = ({ dumpId }) => `${GET_DUMP_FILE}?dump_id=${encodeURIComponent(dumpId)}`;
